export const SIGNUP_REQUEST="SIGNUP_REQUEST";
export const SIGNUP_SUCCESS="SIGNUP_SUCCESS";
export const SIGNUP_FAILURE="SIGNUP_FAILURE";

export const GETSIGNUP_REQUEST="GETSIGNUP_REQUEST";
export const GETSIGNUP_SUCCESS="GETSIGNUP_SUCCESS";
export const GETSIGNUP_FAILURE="GETSIGNUP_FAILURE";

